export default __webpack_public_path__ + "static/map-all-8991179ef9d209288de5e3e7b420e331.svg";